module.exports = __webpack_public_path__ + "img/icon-oildrops.84a1941f.svg";